<template>
  <g>
    <path
      d="M20 3.00024H12C11.45 3.00024 11 3.45024 11 4.00024V5.61024C11 5.61024 11 5.61024 11.01 5.62024L16.01 10.1202C16.64 10.6802 17 11.5002 17 12.3502V13.0002H19V15.0002H17V17.0002H19V19.0002H17V21.0002H20C20.55 21.0002 21 20.5502 21 20.0002V4.00024C21 3.45024 20.55 3.00024 20 3.00024ZM15 7.00024H13V5.00024H15V7.00024ZM19 11.0002H17V9.00024H19V11.0002ZM19 7.00024H17V5.00024H19V7.00024Z"
    />
    <path
      d="M15 20.0002V12.3502C15 12.0702 14.88 11.8002 14.67 11.6102L9.67 7.11022C9.48 6.93022 9.24 6.85022 9 6.85022C8.76 6.85022 8.52 6.94022 8.33 7.11022L3.33 11.6102C3.12 11.7902 3 12.0602 3 12.3502V20.0002C3 20.5502 3.45 21.0002 4 21.0002H6C6.55 21.0002 7 20.5502 7 20.0002V16.0002H11V20.0002C11 20.5502 11.45 21.0002 12 21.0002H14C14.55 21.0002 15 20.5502 15 20.0002Z"
    />
  </g>
</template>
